module.exports = __WEBPACK_EXTERNAL_MODULE__1487__;